import React from "react";
import { Box, Button } from "@material-ui/core";
import {
  ContactMail,
  ContactPhone,
  ChevronRight,
  Info,
  LocationOn,
  Add,
} from "@material-ui/icons/";
import PerfectScrollbar from "react-perfect-scrollbar";
import parsePhoneNumber from "libphonenumber-js";
import { config } from "../../config";
import { useConnect } from "../../context/connect";
import { useStyles } from "./style";
import { Iterable } from "./Iterable";
import { encodeQueryData } from "../../helpers/encodeQueryData";

export const CustomerInfo = () => {
  const classes = useStyles();
  const { contact } = useConnect();

  if (!contact) return null;

  const type = contact.getType();
  const queue = contact.getQueue();
  const attributeMap = contact.getAttributes();
  console.log(attributeMap, "attributeMap attributeMap attributeMap");

  const info =
    attributeMap.Info && attributeMap.Info.value
      ? JSON.parse(attributeMap.Info.value)
      : {};

  const name =
    attributeMap.FirstName || attributeMap.LastName
      ? `${attributeMap.FirstName?.value} ${attributeMap.LastName?.value}`.trim()
      : "";
  const phone =
    parsePhoneNumber(attributeMap.Phone?.value || "")?.formatInternational() ||
    "";
  const mail = attributeMap.Email?.value || "";

  const createOrderLink = encodeQueryData(attributeMap);

  return (
    <Box className={classes.wrapper}>
      <PerfectScrollbar style={{ maxHeight: "100%" }}>
        <Box>
          {!!(name || mail || phone) && (
            <Box className={classes.profile} p={2}>
              <Box display={"flex"}>
                <Box mr={2}>
                  {type === "chat" ? (
                    <ContactMail
                      fontSize="small"
                      style={{ color: "#4a4a4a" }}
                    />
                  ) : (
                    <ContactPhone
                      fontSize="small"
                      style={{ color: "#4a4a4a" }}
                    />
                  )}
                </Box>
                <Box className={classes.profile_info}>
                  {!!name ? (
                    <Box>{name}</Box>
                  ) : !!phone ? (
                    <Box>{phone}</Box>
                  ) : (
                    !!mail && <Box>{mail}</Box>
                  )}
                  {!!(name || phone) && <Box>{mail}</Box>}
                  {!!name && <Box>{phone}</Box>}
                </Box>
                <Box className={classes.icon_container} ml={"auto"}>
                  {!!attributeMap.User_id?.value && (
                    <>
                      <a
                        className={classes.profile_link}
                        href={`${config.platformUrl}/customers/${attributeMap.User_id.value}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={`${config.platformUrl}/customers/${attributeMap.User_id.value}`}
                      >
                        <ChevronRight />
                      </a>
                    </>
                  )}
                  <Button
                    className={classes.createOrderButton}
                    href={createOrderLink}
                    target="_blank"
                    size="small"
                    startIcon={<Add />}
                    rel="noopener noreferrer"
                    variant="outlined"
                  >
                    Create order
                  </Button>
                </Box>
              </Box>
            </Box>
          )}

          <Box display={"flex"} className={classes.profile} p={2}>
            <Box mr={2}>
              <Info fontSize="small" />
            </Box>
            <Box>
              {!!attributeMap.InitPage?.value && (
                <Box display={"flex"} alignItems={"center"} mb={0.5}>
                  <Box mr={1} className={classes.title}>
                    Came from:
                  </Box>
                  <Box flex={1} overflow={"hidden"}>
                    <a
                      className={classes.link}
                      style={{
                        display: "block",
                        width: "370px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      href={attributeMap.InitPage.value}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {attributeMap.InitPage.value}
                    </a>
                  </Box>
                </Box>
              )}

              {queue && (
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    mr={1}
                    className={classes.title}
                    width={attributeMap.InitPage ? "75px" : "auto"}
                  >
                    Queue:
                  </Box>
                  <Box>{queue.name}</Box>
                </Box>
              )}
            </Box>
          </Box>
          {!!attributeMap.Info?.value && (
            <Box display={"flex"} className={classes.profile} p={2}>
              <Box mr={2}>
                <LocationOn fontSize="small" />
              </Box>
              <Box>
                <Box display={"flex"} alignItems={"center"}>
                  <Box mr={1} className={classes.title}>
                    Ip:
                  </Box>
                  <Box>{info.ip || "~"}</Box>
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  <Box mr={1} className={classes.title}>
                    Country:
                  </Box>
                  <Box>{info.country_name || "~"}</Box>
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  <Box mr={1} className={classes.title}>
                    Region:
                  </Box>
                  <Box>{info.region_name || "~"}</Box>
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  <Box mr={1} className={classes.title}>
                    City:
                  </Box>
                  <Box>{info.city || "~"}</Box>
                </Box>
              </Box>
            </Box>
          )}
          <Iterable />
        </Box>
      </PerfectScrollbar>
    </Box>
  );
};
